import { SignInButton, SignUpButton, UserButton, useAuth } from "@clerk/clerk-react";

export const AuthNav = () => {
  const { isSignedIn } = useAuth();

  if (isSignedIn) {
    return <UserButton afterSignOutUrl="/" />;
  }

  return (
    <div className="flex gap-4 items-center">
      <SignInButton mode="modal">
        <button className="text-gray-600 hover:text-blue-600 font-medium">
          Sign in
        </button>
      </SignInButton>
      <SignUpButton mode="modal">
        <button className="bg-blue-600 text-white px-4 py-2 rounded-md hover:bg-blue-700">
          Sign up
        </button>
      </SignUpButton>
    </div>
  );
};
